var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25026 1.39159C4.73558 1.28614 4.20487 1.28614 3.69019 1.39159C3.53036 1.42434 3.40729 1.55228 3.38075 1.71327L3.36123 1.83175C3.20051 2.80692 3.20051 3.80183 3.36123 4.777L3.38075 4.89548C3.40729 5.05646 3.53036 5.1844 3.69019 5.21715C4.20487 5.32261 4.73559 5.32261 5.25026 5.21715C5.4101 5.1844 5.53317 5.05646 5.5597 4.89548L5.57923 4.777C5.73994 3.80182 5.73994 2.80692 5.57923 1.83175L5.5597 1.71327C5.53317 1.55228 5.4101 1.42434 5.25026 1.39159Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91144 3.93727C2.05913 3.91634 2.19583 4.0191 2.21675 4.1668L2.37899 5.31175C2.42283 5.6211 2.66805 5.86298 2.97797 5.90257C3.96878 6.02912 4.97167 6.02912 5.96249 5.90257C6.27241 5.86298 6.51763 5.6211 6.56146 5.31176L6.7237 4.1668C6.74463 4.0191 6.88133 3.91634 7.02902 3.93727C7.17671 3.9582 7.27948 4.09489 7.25855 4.24259L7.09631 5.38754C7.01834 5.93777 6.58218 6.36799 6.03093 6.4384C5.6023 6.49315 5.1715 6.52526 4.74033 6.53471V7.98604C4.74033 8.13521 4.61941 8.25614 4.47024 8.25614C4.32107 8.25614 4.20014 8.13521 4.20014 7.98604V6.53471C3.76897 6.52526 3.33816 6.49316 2.90952 6.4384C2.35828 6.36799 1.92211 5.93777 1.84415 5.38754L1.6819 4.24259C1.66098 4.09489 1.76374 3.9582 1.91144 3.93727Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.f8d7b635febf4e6be623d3a0646a023b.svg";
export { ForwardRef as ReactComponent };